import React, { FC, useEffect, useState } from "react";
import { MenuItem, Select, Typography } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

interface Props {
  onUpdate: (key: string, value: string) => void;
  settings: any;
  fonts: any;
}

export const FontFamilySelector: FC<Props> = ({
  settings,
  onUpdate,
  fonts,
}) => {
  const [index, setIndex] = useState(0);

  const updateFontIndex = (e: any) => {
    const currentIndex = parseInt(e.target.value, 10);
    onUpdate("fontIndex", currentIndex.toString());
  };

  useEffect(() => {
    const { fontIndex } = settings;
    setIndex(parseInt(fontIndex, 10) || 0);
  }, [settings, fonts]);

  return (
    <div className="flex flex-col gap-2">
      <Typography color="var(--text)">
        Text font
      </Typography>
      <Select
        size="small"
        className="!rounded-md !border-0 bg-surface-2"
        value={index}
        onChange={updateFontIndex}
        IconComponent={KeyboardArrowDown}
        notched
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            display: "none",
          },
        }}
      >
        <MenuItem value={0}>
          <Typography sx={{ opacity: 0.5 }}>Select Font</Typography>
        </MenuItem>
        {fonts?.map((item: any, i: any) => (
          <MenuItem
            key={i + 1}
            value={i + 1}
            style={{ fontFamily: `'${item.family}', ${item.category}` }}
          >
            {item.family}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
